import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { IKnmAccessLevel } from '../interfaces/IKnmAccessLevel';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { handleResponse } from '../../MainModule/common/handleResponse';

export async function fetchKnmAccessLevel(): Promise<IKnmAccessLevel[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-access-level`;
  const mockData = apiMockSwitcher<IKnmAccessLevel[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
